module.exports = __webpack_public_path__ + "static/media/Car-image.c6212b7c.svg";